import DokanIcons from '../icon/DokanIcons';

const DokanInputLabel = ({ metaLabel, isIcon, icon, children }) => (
    <>
        <div className="inline-grid grid-flow-col gap-3">
            <div>
                <p className="text-base font-bold mt-6">{children}</p>
            </div>
            {metaLabel && (
                <div>
                    <p className="text-tertiary font-thin mt-5">{metaLabel}</p>
                </div>
            )}
            <div>
                {isIcon && (
                    <div className="mt-25px">
                        <DokanIcons icon={icon} size="3" />
                    </div>
                )}
            </div>
        </div>
    </>
);

export default DokanInputLabel;
